<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ t('Report visibility') }}</h2>

  <mat-dialog-content>
    @if (loading()) {
      <div class="loading-wrap">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    } @else {
      <p class="description">
        {{ t('report_visibility_description') }}
      </p>

      <div class="visibility-toggle">
        <mat-slide-toggle
          [formControl]="visibilityControl"
          [disabled]="saving()"
        >
          {{ t('Visible to all clinics') }}
        </mat-slide-toggle>
        <p class="hint">
          {{
            visibleToAllClinics()
              ? t('report_visible_all_hint')
              : t('report_visible_private_hint')
          }}
        </p>
      </div>

      @if (!visibleToAllClinics()) {
        <div class="clinic-share-section">
          <h3>{{ t('Share with specific clinics') }}</h3>

          <mat-form-field appearance="outline" class="search-field">
            <mat-label>{{ t('Search') }}</mat-label>
            <input matInput [formControl]="searchControl" />
          </mat-form-field>

          <div
            class="clinic-list"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="100"
            [scrollWindow]="false"
            (scrolled)="loadMoreClinics()"
          >
            @if (loadingClinics() && !clinics().length) {
              <div class="loading-wrap loading-wrap--inline">
                <mat-spinner diameter="24"></mat-spinner>
              </div>
            } @else {
              @for (clinic of clinics(); track clinic.uid) {
                <div class="clinic-row">
                  <div class="clinic-info">
                    <span class="clinic-name">{{ clinic.name }}</span>
                    @if (clinic.address) {
                      <span class="clinic-address">{{ clinic.address }}</span>
                    }
                  </div>
                  <button
                    mat-button
                    type="button"
                    class="share-btn"
                    [disabled]="saving()"
                    (click)="toggleClinicShare(clinic)"
                  >
                    {{
                      clinic.isShared
                        ? t('Revoke share')
                        : t('Share report')
                    }}
                  </button>
                </div>
              } @empty {
                <p class="empty">{{ t('No clinics found') }}</p>
              }
            }
            @if (loadingMore()) {
              <div class="load-more-wrap">
                <mat-spinner diameter="20"></mat-spinner>
              </div>
            }
          </div>
        </div>
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button class="secondary-btn" (click)="close()">
      {{ t('Close') }}
    </button>
  </mat-dialog-actions>
</ng-container>
